'use client';

import { Media, OwnerType, PageStatus, PointOfView } from '../../lib/graphql';
import React, { PropsWithChildren } from 'react';

import { useNonNullableContext } from '../../hooks/useNonNullableContext';

export interface Page {
  id: string;
  slug: string;
  url: string;
  title: string;
  status: PageStatus;
  cover: {
    type: Exclude<Media['__typename'], undefined>;
    url: string;
  } | null;
  owner: {
    id: string;
    name: string;
    avatar?: string | null;
  };
  product: {
    name: string;
    ownerType: OwnerType;
    allowedPointsOfView: PointOfView[];
  };
  charity: {
    name: string;
    countryCode: string | null;
    landingPageUrl: string;
    externalId: number;
  };
  currencyCode: string;
  targetAmount?: number;
  donationSummary: {
    totalAmount: number;
  };
  donationCount: number;
  branding: {
    primaryColor?: string | null;
  };
  event?: {
    id: string;
    externalId: number;
    endDate?: Date;
  };
  campaign?: {
    id: string;
  };
  fundraisers: {
    totalCount: number;
    items: {
      id: string;
      ownerAvatarUrl?: string | null;
    }[];
  };
}

const PageContext = React.createContext<Page | null>(null);
PageContext.displayName = 'PageContext';

interface PageProviderProps extends PropsWithChildren {
  page: Page;
}

export const PageProvider: React.FC<PageProviderProps> = ({
  children,
  page,
}) => {
  return <PageContext.Provider value={page}>{children}</PageContext.Provider>;
};

export const usePage = () => useNonNullableContext(PageContext);
